import React from "react";
import { InputMask } from "primereact/inputmask";
import CustomInput from "./Input";

// ENG-1826: one CP page field: locked with its value on file, or an input the signer must fill before Submit.
const CpFieldInput = ({ name, field, input, locked, value, onChange }) => {
  const style = { height: field.height };
  if (locked) {
    return (
      <CustomInput
        name={name}
        type="text"
        disabled
        placeholder={field.field_name}
        className="border-none text-xs disabled:bg-transparent disabled:cursor-default"
        style={style}
        value={value}
      />
    );
  }
  if (input === "date" || input === "phone") {
    const mask = input === "date" ? "99/99/9999" : "(999) 999-9999";
    const hint = input === "date" ? "MM/DD/YYYY" : "(999) 999-9999";
    return (
      <InputMask
        name={name}
        id={name}
        className="pointer-events-auto text-xs border-gray-300"
        style={{ ...style, width: field.width }}
        placeholder={hint}
        value={value}
        mask={mask}
        slotChar={input === "date" ? hint : "_"}
        inputMode="numeric"
        onChange={(e) => onChange(e.target.value ?? "")}
      />
    );
  }
  if (input === "textarea") {
    return (
      <textarea
        name={name}
        id={name}
        rows={2}
        placeholder={field.field_name}
        className="pointer-events-auto block border border-gray-300 rounded px-1 py-0 resize-none overflow-y-auto"
        style={{ ...style, width: field.width, fontSize: 10, lineHeight: "12px" }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
  if (input === "gender") {
    return (
      <select
        name={name}
        className="pointer-events-auto text-xs border-gray-300"
        style={{ ...style, width: field.width }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Prefer not to say</option>
      </select>
    );
  }
  return (
    <CustomInput
      name={name}
      type={input}
      placeholder={field.field_name}
      className="text-xs"
      style={style}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default CpFieldInput;
